import React, { useEffect, useMemo, useState } from "react";
import styles from "./App.module.css";
import {
  Navbar,
  Header,
  About,
  Experience,
  Projects,
  Testimonials,
  Contact,
} from "./components";

const App = () => {
  const [scrollPosition, setScrollPosition] = useState<number>(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const projects = useMemo(() => {
    return <Projects />;
  }, []);

  const testimonials = useMemo(() => {
    return <Testimonials />;
  }, []);

  return (
    <div className={styles.container}>
      <Navbar />
      <Header />
      <About />
      <Experience />
      {projects}
      {testimonials}
      <Contact />
      <div
        className={`${styles.fixed__arrow} ${
          scrollPosition > 890 && styles.show__arrow
        }`}
      >
        <a href="#navbar">
          <img
            src="https://cdn3d.iconscout.com/3d/premium/thumb/arrow-up-2891380-2409787@0.png"
            alt=""
          />
        </a>
      </div>
    </div>
  );
};

export default App;
